import { toast } from "$global-providers/toast-provider";
import { gql } from "@apollo/client";
import { defineMessage, useIntl } from "react-intl";
import { useVoidInvoiceMutation } from "./__generated__/useVoidInvoice.gql";

const ERROR_MESSAGE = defineMessage({
  id: "invoicing.voidInvoice.error.msg",
  defaultMessage: "Failed to void this invoice",
});

gql`
  mutation voidInvoice($input: VoidInvoiceInput!) {
    voidInvoice(input: $input) {
      _id
      patientType
      created
      updated
      invoiceStatus
      balance {
        total
        paid
        due
        currency
      }
    }
  }
`;

export default function useVoidInvoice(invoiceId: string) {
  const { formatMessage } = useIntl();
  const [voidInvoice] = useVoidInvoiceMutation({
    onError() {
      toast.error(formatMessage(ERROR_MESSAGE), {});
    },
  });

  const voidUnpaidInvoice = async (reason) => {
    return voidInvoice({
      variables: {
        input: {
          _id: invoiceId,
          reason,
        },
      },
    });
  };

  return { voidUnpaidInvoice };
}
